<template>
    <b-button
        ref="dashboardButton"
        class='dashboard-button'
        :class="disabled ? 'set-disabled' : ''"
        v-b-tooltip.hover
        :title="(disabled) ? disabledMessage : null"
        :to="!disabled && toName ? { name: toName } : null"
        variant="outline-info"
        @click="buttonClick"
    >
        <div class="container h-100">
            <div class="row align-items-center h-100">
                <div class="col-8 text-left">
                    <span class="dashboard-button-title">{{ buttonTitle }}</span>
                </div>

                <div class="col-4 h-100 d-flex align-items-center">
                    <loader v-if="loading"
                        color="#17a2b8"
                        size="4rem"
                        thickness="6px"
                    />

                    <fa-icon
                        v-else
                        :icon="iconName"
                        class="dashboard-button-icon p-1"
                    />
                </div>
            </div>
        </div>
    </b-button>
</template>

<script>
import Loader from './Loader';

export default {
    components: { 
        Loader,
    },
    props: {
        toName: {
            type: String,
            default: null,
        },
        buttonTitle: {
            type: String,
            default: 'Placeholder Title',
        },
        iconName: {
            type: String,
            default: 'times',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        disabledMessage: {
            type: String,
            default: 'Deze knop is tijdelijk uitgeschakeld',
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        disabled: function(value) {
            if (!value) {
                this.$refs.dashboardButton.removeAttribute('data-original-title');
            }
            else {
                this.$refs.dashboardButton.setAttribute('data-original-title', this.disabledMessage);
            }
        },
    },
    methods: {
        buttonClick() {
            if (!this.disabled)
                this.$emit('click');
        },
    }

}
</script>

<style lang="scss">
.dashboard-button {
    height: 100px;
    width: 100%;

    &.set-disabled {
        opacity: 0.5;
    }

    &:focus, &:active, &:focus:active {
        outline: none !important;
        box-shadow: none !important;
    }

    .dashboard-button-title {
        font-size: 1.5rem;
    }

    .dashboard-button-icon {
        width: 100%;
        height: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// DashboardIconButton.vue?27bbc489